import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SacyrDataTableComponent } from './sacyr-data-table.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MaterialModule } from '../../material.module';

@NgModule({
  declarations: [
    SacyrDataTableComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MaterialModule,
    NgxDatatableModule,
  ],
  exports: [
    SacyrDataTableComponent
  ],
})

export class SacyrDataTableModule { }